module.exports = __webpack_public_path__ + "img/智慧污水管理系统解决方案.e6f95669.jpg";